import {ObjectDTO} from "./object-dto";

export class MotifNonConformiteDTO extends ObjectDTO {

  libelle:string;
  code:string;
  actif:boolean;

}
